<template>
  <el-row :gutter="10" style="margin-bottom:10px">
    <el-col :span="4">
      <el-cascader
          v-model="deptId"
          :show-all-levels="false"
          :options="deptCascader"
          :props="optionProps"
          placeholder="部门"
          clearable
      ></el-cascader>
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeNo" placeholder="员工工号" clearable/>
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeName" placeholder="员工姓名" clearable/>
    </el-col>
    <el-col :span="5">
      <el-date-picker v-model="selectMonth" type="month" placeholder="请选择月份" value-format="YYYY-MM"/>
    </el-col>
    <el-col :span="6">
      <el-button type="primary" @click="getSalaryList" :loading="searchLoading" >搜索</el-button>
      <el-button type="primary" plain @click="exportMonthReport">导出扣税薪资</el-button>
    </el-col>
  </el-row>
  <el-row style="margin-bottom:10px">
    <el-col :span="10">
      <FrameButton :button="calculateBtn"></FrameButton>
      <el-button type="primary" plain @click="exportMonthReport">导出未税薪资</el-button>
    </el-col>
  </el-row>
  <el-table :data="pageSalaryList" stripe border style="width: 100%;height: 77%" row-style="height:28px;" size="small">
    <el-table-column label="工号" prop="employee_no" fixed width="70" align="center" ></el-table-column>
    <el-table-column label="姓名" prop="employee_name" fixed width="80" align="center" ></el-table-column>
    <el-table-column label="部门" prop="department_name" fixed width="100" align="center" ></el-table-column>
    <el-table-column label="月份" prop="work_month_str" width="70" align="center" ></el-table-column>
    <el-table-column label="应发工资" prop="payable" align="center" >
      <el-table-column label="基本薪资" prop="basic_salary" width="80" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="绩效工资" prop="salary_merit" width="80" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="岗位津贴" prop="salary_job_allowance" width="80" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="奖金" prop="salary_award" width="60" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="餐补" prop="salary_meal" width="70" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="话费补贴" prop="salary_phone" width="80" align="center" :formatter="formatSalary"></el-table-column>
    </el-table-column>
    <el-table-column label="提成" prop="commission" width="45" align="center" :formatter="formatSalary"></el-table-column>
    <el-table-column label="季度全勤" prop="award_full_attendance" width="80" align="center" :formatter="formatSalary"></el-table-column>
    <el-table-column label="加班补贴" prop="salary_overtime" width="80" align="center" :formatter="formatSalary"></el-table-column>
    <el-table-column label="出差补贴" prop="subsidy_out" width="80" align="center" :formatter="formatSalary"></el-table-column>
    <el-table-column label="销售绩效" prop="sell_merit" width="80" align="center" :formatter="formatSalary"></el-table-column>
    <el-table-column label="电销补贴" prop="subsidy_telemarketing" width="80" align="center" :formatter="formatSalary"></el-table-column>
    <el-table-column label="季度奖金" prop="quarterly_bonus" width="80" align="center" :formatter="formatSalary"></el-table-column>
    <el-table-column label="项目奖金" prop="project_bonus" width="80" align="center" :formatter="formatSalary"></el-table-column>
    <el-table-column label="应扣" prop="deduction" align="center" >
      <el-table-column label="请假" prop="cut_payment_personal" width="80" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="迟到早退" prop="cut_payment_late" width="80" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="缺卡" prop="cut_payment_miss_sign" width="60" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="旷工" prop="cut_payment_absent" width="80" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="代扣社保" prop="withholding_social" width="80" align="center" :formatter="formatSalary" ></el-table-column>
      <el-table-column label="代扣公积金" prop="withholding_fund" width="85" align="center" :formatter="formatSalary"></el-table-column>
      <el-table-column label="代扣个税" prop="withholding_tax" width="80" align="center" :formatter="formatSalary"></el-table-column>
    </el-table-column>
    <el-table-column label="实发工资" prop="salary_actual" width="80" align="center" :formatter="formatSalary"></el-table-column>
  </el-table>
  <div style="display: flex;justify-content: flex-end;margin-top: 5px;width: 100%">
    <el-pagination background layout=" sizes, total, prev, pager, next,"
                   :page-sizes="[15,20,30]"
                   :current-page="currentPage"
                   v-model:page-size="pageSize"
                   :total="listSize"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"/>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "SalaryMonth",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      calculateBtn:{
        "component": "button",
        "label": "薪资计算",
        "type":"primary",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "salary_month_sum","title":"薪资计算","width":800,"height":600}
      },
      optionProps: {
        emitPath:false,
        value: 'id',
        label: 'name',
        checkStrictly:true
      },
      searchLoading: false,
      caculateLoading: false,
      computationLoading:false,
      titleList: [],
      salaryList: [],
      pageSalaryList: [],
      pageSize:15,
      listSize:0,
      currentPage:1,
      columnCnt:0,
      deptId:'',
      employeeNo:'',
      employeeName:'',
      sendStatus:'',
      confirmStatus:'',
      selectMonth:moment(moment().month(moment().month()-1)).format('YYYY-MM'),
      laborCompanyId:'',
      showDialog:false,
      selectEmployee:{},
      employeeAttendanceList:[],
      deptCascader:[],
      laborCompanyList:[]
    }
  },
  methods: {
    spanMethod({rowIndex, columnIndex}){
      if (columnIndex <30 || columnIndex === this.titleList.length+31) {
        if (rowIndex % 4 === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    formatSalary(row, column, cellValue) {
      if (cellValue == null || isNaN(cellValue)) {
        return "";
      }
      // 格式化金额，保留两位小数，去除多余的零
      return cellValue.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getCurrentPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getCurrentPageData();
    },
    getCurrentPageData(){
      if(!this.salaryList){
        return
      }
      let startIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = this.currentPage * this.pageSize;
      this.pageSalaryList = this.salaryList.slice(startIndex, endIndex)

    },
    async getSalaryList() {
      let params = {
        deptId: this.deptId,
        employeeNo: this.employeeNo,
        employeeName: this.employeeName,
        selectMonth: this.selectMonth
      }
      console.log(params);
      this.searchLoading = true;
      await this.$http('salaryMonthService.getSalaryList', params, false).then(rtn => {
        //赋值
        this.salaryList = rtn;
        this.listSize = rtn.length;
        this.getCurrentPageData();
        this.searchLoading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        this.searchLoading = false;
      })
    },
    async caculate() {

    },
    async getDepartmentCascader() {
      this.deptCascader = await this.$http("sysUserDepartmentService.getDepartmentData");
    },
    async exportMonthReport() {
      let params = {
        salaryList: this.salaryList
      }
      let sysFile = await this.$http("salaryMonthService.exportSalaryToExcel", params);
      window.location.href = sysFile.url;
    }
  },
  created() {
    this.getDepartmentCascader();
  }
}
</script>

<style scoped lang="less">

</style>